module.exports = __webpack_public_path__ + "img/image_3-5a871df8.png";